module.exports = __webpack_public_path__ + "img/logout.4c0588e1.svg";